var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "checkout-cart-button",
      class: {
        "checkout-cart-button--sticky": _vm.sticky,
      },
      attrs: { type: "button" },
      on: { click: _vm.onClick },
    },
    [
      _c("span", {
        staticClass: "checkout-cart-button__total",
        domProps: {
          innerHTML: _vm._s(_vm.$options.filters.madpricecent(_vm.total)),
        },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "checkout-cart-button__count",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("checkout.itemCount", {
              number: _vm.totalItemsWithoutAdditional,
            })
          ),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }